import { AnySchema } from 'ajv';

import { FieldErrorMessage } from '../../../../models/FieldErrorMessage';
import { contractFormSchema } from '../../../../styledComponents/Forms/SelectContractForm/selectContractForm.validation';
import { subscriptionOptionsSchema } from '../../../../styledComponents/Forms/SubscriptionOptions/subscriptionOptions.validation';
import { subscriptionSummarySchema } from '../../../../styledComponents/FormSummary/SubscriptionSummary/subscriptionSummary.validation';
import { validateFormData } from '../../../../utils/validations/validateFormData';
import { IEditDOCOrganizationSubscriptionModel } from '../../../../models/interfaces/Subscription/DutyOfCare/EditDOCOrganizationSubscriptionModel';
import { docRenewSubscriptionDetailsSchema } from '../../../../styledComponents/RenewSubscriptionFormPage/FormSections/DutyOfCareRenewSubscription/DOCRenewSubscriptionDetails/docRenewSubscriptionDetails.validation';
import { docRenewSubscriptionSchema } from '../../../../styledComponents/RenewSubscriptionFormPage/FormSections/DutyOfCareRenewSubscription/dutyOfCareRenewSubscriptionForm.validation';

const schema: AnySchema | any = {
  type: 'object',
  properties: {
    ...docRenewSubscriptionDetailsSchema.properties,
    ...subscriptionOptionsSchema.properties,
    ...subscriptionSummarySchema.properties,
    ...docRenewSubscriptionSchema.properties,
  },
  dependencies: {
    ...subscriptionOptionsSchema.dependencies,
    ...subscriptionSummarySchema.dependencies,
  },
  required: [
    ...contractFormSchema.required,
    ...docRenewSubscriptionSchema.required,
    ...subscriptionOptionsSchema.required,
    ...subscriptionSummarySchema.required,
  ],
};

export const validateDOCEditRenewSubscriptionForm = (
  data: IEditDOCOrganizationSubscriptionModel,
  additionalErrors?: FieldErrorMessage[],
) => validateFormData(data, additionalErrors, schema);
